import React, {Component, ReactComponentElement} from 'react';
import ReactGA from 'react-ga';
import {RouteComponentProps} from "react-router";

export default function withTracker(WrappedComponent: any, options = {}) {
    const trackPage = (page: string) => {
        ReactGA.set({
            page,
            ...options
        });
        ReactGA.pageview(page);
    };

    const HOC = class extends Component<RouteComponentProps> {
        componentDidMount() {
            const page = this.props.location.pathname + this.props.location.search;
            trackPage(page);
        }

        componentWillReceiveProps(nextProps: RouteComponentProps) {
            const currentPage = this.props.location.pathname + this.props.location.search;
            const nextPage = nextProps.location.pathname + nextProps.location.search;

            if (currentPage !== nextPage) {
                trackPage(nextPage);
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };

    return HOC;
}